module.exports = __webpack_public_path__ + "static/media/everyone-setting-icon.3ac35e37.svg";